<span class="inline-flex" [matTooltip]="computedTooltip" (click)="onClick($event)">
  @if (genericRouteName) {
    <a mat-fab [mxNamedRouterLink]="genericRouteName" [mxNamedRouterLinkParams]="routeParams" [mxQueryParams]="queryParams"
       [mxNamedRouterLinkEnabled]="enabled" [color]="color" [attr.aria-disabled]="computedAriaDisabled" [attr.tabindex]="computedTabIndex"
       [attr.aria-label]="computedAriaLabel" class="mx-button-component {{ buttonClasses }}">
      <ng-container *ngTemplateOutlet="buttonContent"/>
    </a>
  } @else if (href) {
    <a mat-fab [attr.href]="computedHref" [target]="externalLinkTarget" [rel]="externalLinkRelationship" [color]="color"
       [attr.aria-disabled]="computedAriaDisabled" [attr.tabindex]="computedTabIndex" [attr.aria-label]="computedAriaLabel"
       class="mx-button-component {{ buttonClasses }}">
      <ng-container *ngTemplateOutlet="buttonContent"/>
    </a>
  } @else {
    <button mat-fab [type]="type" [color]="color" [disabled]="!enabled" [attr.aria-label]="computedAriaLabel" class="mx-button-component {{ buttonClasses }}">
      <ng-container *ngTemplateOutlet="buttonContent"/>
    </button>
  }
</span>

<ng-template #buttonContent>
  @if (customContentTemplate) {
    <span class="mx-button-custom-content">
      <ng-container [ngTemplateOutlet]="customContentTemplate"/>
    </span>
  } @else {
    <mat-icon [class]="iconClasses" [class.material-icons-outlined]="iconOutlined">{{ icon }}</mat-icon>
  }
</ng-template>
